import React, { useContext, useEffect, useRef } from 'react'
import { Field, Form, Formik } from 'formik';
import { getImages } from '../Common/const'
import ValidationError from '../Errors/ValidationError';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-time-picker/dist/TimePicker.css';
import { useState } from 'react';
import { VehicleContext } from '../Context/VehicleContext';
import { useNavigate } from 'react-router-dom';

const ScheduleServiceModal = ({ close }) => {
    const {submitContactForm, vehicleListSearch} = useContext(VehicleContext);

    const navigate = useNavigate();
    
    const [date, setDate] = useState(null);

    const [vehicleYears,setVehicleYears] = useState([]);
    const [vehicleMakes,setVehicleMakes] = useState([]);
    const [vehicleModels,setVehicleModels] = useState([]);
    const [vehicleTrims,setVehicleTrims] = useState([]);

    const [vehicleYearData,setVehicleYearData] = useState([]);

    const formikRef = useRef();

    useEffect(() => {

        if(!vehicleYears || vehicleYears.length === 0) {

            getVehicleYears();
        } 
    },[]);

    const getVehicleYears = async () => {
        const data = await vehicleListSearch({'subject':'year'});
        console.log(data);
        setVehicleYears(data);
    }

    const getVehicleYearData = async (year) => {
        const data = await vehicleListSearch({'subject':'yeardata','year':year});
        console.log(data);

        setVehicleYearData(data);
        
        let makes = [];
        
        if('makes' in data) {
            data['makes'].map((make,i) => {
                makes.push(make.name);
            });

            setVehicleMakes(makes);
        }
    }

    const getVehicleModels = async (year,make) => {        
        console.log(year,make);

        if('makes' in vehicleYearData) {

            let models = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make,i) => {
                console.log(make);
                if('models' in make) {
                    make['models'].map((model,j) => {
                        models.push(model.name);
                    })
                }
            });

            setVehicleModels(models);
        }
    }

    const getVehicleTrims = async (year,make,model) => {        
        console.log(year,make,model);

        if('makes' in vehicleYearData) {

            let trims = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make,i) => {
                console.log(make);
                if('models' in make) {
                    make['models'].filter((item) => item.name == model).map((model,j) => {
                        if('trims' in model) {
                            model['trims'].map((trim,k) => {
                                trims.push(trim.name);
                            })
                        }
                    })
                }
            });

            setVehicleTrims(trims);
        }
    }

    const generateTimes = () => {
        const times = [];
        let currentTime = new Date();
        currentTime.setHours(8, 0, 0); // Set time to 8:00 AM
        
        const endTime = new Date();
        endTime.setHours(17, 0, 0); // Set time to 5:00 PM
        
        while (currentTime <= endTime) {
            const formattedTime = currentTime.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            });
            times.push(formattedTime);
            currentTime.setMinutes(currentTime.getMinutes() + 30); // Increment by 30 minutes
        }
        return times;
    }

    const timeList = generateTimes();

    return (
        <>
            <div className="modal-content p-0">

                <Formik
                    // validationSchema={validationSchema}
                    initialValues={{
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone: '',
                        date: null,
                        time: '',
                        contactMethod: [],
                        year: '',
                        make: '',
                        model: '',
                        trim: '',
                        mileage: '',
                        comment: '',
                        service_form: true
                    }}
                    innerRef={formikRef}
                    onSubmit={async (values, { resetForm }) => {
                        console.log(values);
                        const data = await submitContactForm(values);
                        if (data.success) {
                            resetForm();
                            navigate("/thank-you");
                        } else
                            alert("There was a problem with your submission");
                    }}
                >
                    {({ values, setFieldValue, field, form }) => (
                        <Form className="schedule-service-form" autoComplete="off" name="schedule-service-form">
                            <Field type="hidden" name="service_form" value="true" />
                            <div className="modal-header">
                                <h1 className="xs-title text-uppercase text-center w-100">
                                    Schedule Service
                                </h1>
                                <button className="sm-box-close" type="button" onClick={close}>
                                    <img src={getImages('white-close.svg')} />
                                </button>
                            </div>
                            <div className="modal-body ss-modal-body">
                                <div className='row'>
                                    <div className='col-lg-6 col-12 mb-4'>
                                        <div className='sm-title text-lgray fw-500 text-uppercase mb-3'>1. Customer Info</div>
                                        <div className='ss-gray-box'>
                                            <div className='row'>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>First Name</label>
                                                        <Field
                                                            type="text"
                                                            name="first_name"
                                                            className="form-control"
                                                            required
                                                        />
                                                        <ValidationError name="first_name" />
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>Last Name</label>
                                                        <Field
                                                            type="text"
                                                            name="last_name"
                                                            className="form-control"
                                                            required
                                                        />
                                                        <ValidationError name="last_name" />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className='form-group'>
                                                        <label>Email</label>
                                                        <Field
                                                            type="email"
                                                            name="email"
                                                            className="form-control"
                                                            required
                                                        />
                                                        <ValidationError name="email" />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className='form-group'>
                                                        <label>Phone</label>
                                                        <Field
                                                            type="phone"
                                                            name="phone"
                                                            className="form-control"
                                                            required
                                                        />
                                                        <ValidationError name="phone" />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className='xs-title text-gray font-15 fw-500 text-uppercase mt-3 mb-2'>When Would You Like to Come In?</div>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>Date</label>
                                                        <DatePicker
                                                            selected={date}
                                                            onChange={(val) => {
                                                                setDate(val);
                                                                setFieldValue('date', val);
                                                            }}
                                                            className="form-control w-100"
                                                            dateFormat="yyyy-MM-dd"
                                                            placeholderText="Select a date"
                                                        />
                                                        <ValidationError name="date" />
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>Time</label>
                                                        <Field
                                                            as="select"
                                                            name="time"
                                                            className="form-control"
                                                        >
                                                            <option value=''>
                                                                Select
                                                            </option>
                                                            {timeList.map((time, index) => (
                                                                <option key={index} value={time}>
                                                                    {time}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ValidationError name="time" />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className='xs-title text-gray font-15 fw-500 text-uppercase mt-3 mb-2'>HOW Should we CONTACT YOU?</div>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className="custom-checkbox ss-checkbox">
                                                            <Field
                                                                type="checkbox"
                                                                name="contactMethod"
                                                                value="Call"
                                                                id='contactMethod1'
                                                            />
                                                            <label htmlFor="contactMethod1" className='w-100'>Call</label>
                                                        </div>
                                                        <div className="custom-checkbox ss-checkbox">
                                                            <Field
                                                                type="checkbox"
                                                                name="contactMethod"
                                                                value="Text"
                                                                id='contactMethod2'
                                                            />
                                                            <label htmlFor="contactMethod2" className='w-100'>Text</label>
                                                        </div>
                                                        <div className="custom-checkbox ss-checkbox">
                                                            <Field
                                                                type="checkbox"
                                                                name="contactMethod"
                                                                value="Email"
                                                                id='contactMethod3'
                                                            />
                                                            <label htmlFor="contactMethod3" className='w-100'>Email</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-12 mb-4'>
                                        <div className='sm-title text-lgray fw-500 text-uppercase mb-3'>2. Vehicle Info</div>
                                        <div className='ss-gray-box'>
                                            <div className='row'>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>Year</label>
                                                        <Field
                                                            as="select"
                                                            name="year"
                                                            className="form-control"
                                                            onChange={(e) => { setFieldValue('year',e.target.value); getVehicleYearData(e.target.value); }}
                                                        >
                                                            <option value=''>
                                                                Select
                                                            </option>
                                                            {vehicleYears.map((v, i) => (
                                                                <option key={i} value={v}>
                                                                    {v}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ValidationError name="year" />
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>Make</label>
                                                        <Field
                                                            as="select"
                                                            name="make"
                                                            className="form-control"
                                                            onChange={(e) => { setFieldValue('make',e.target.value); getVehicleModels(values.year,e.target.value); }}
                                                        >
                                                            <option value=''>
                                                                Select
                                                            </option>
                                                            {vehicleMakes.map((v, i) => (
                                                                <option key={i} value={v}>
                                                                    {v}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ValidationError name="make" />
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>Model</label>
                                                        <Field
                                                            as="select"
                                                            name="model"
                                                            className="form-control"
                                                            onChange={(e) => { setFieldValue('model',e.target.value); getVehicleTrims(values.year,values.make,e.target.value); }}
                                                        >
                                                            <option value=''>
                                                                Select
                                                            </option>
                                                            {vehicleModels.map((v, i) => (
                                                                <option key={i} value={v}>
                                                                    {v}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ValidationError name="model" />
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>Trim</label>
                                                        <Field
                                                            as="select"
                                                            name="trim"
                                                            className="form-control"
                                                            onChange={(e) => { setFieldValue('trim',e.target.value);  }}
                                                        >
                                                            <option value=''>
                                                                Select
                                                            </option>
                                                            {vehicleTrims.map((v, i) => (
                                                                <option key={i} value={v}>
                                                                    {v}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ValidationError name="trim" />
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className='form-group'>
                                                        <label>Mileage</label>
                                                        <Field
                                                            type="text"
                                                            name="mileage"
                                                            className="form-control"
                                                        />
                                                        <ValidationError name="mileage" />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className='form-group'>
                                                        <label>Comments</label>
                                                        <Field
                                                            type="text"
                                                            name="comment"
                                                            className="form-control h-172"
                                                            component="textarea" />
                                                        <ValidationError name="comment" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='text-end'>
                                    <button type='submit' className='btn-theme w-330 text-uppercase text-gray'>Send</button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}

export default ScheduleServiceModal